import { render, staticRenderFns } from "./RegionalAlarmInfos.vue?vue&type=template&id=7c621df0&scoped=true&"
import script from "./RegionalAlarmInfos.vue?vue&type=script&lang=js&"
export * from "./RegionalAlarmInfos.vue?vue&type=script&lang=js&"
import style0 from "./RegionalAlarmInfos.vue?vue&type=style&index=0&id=7c621df0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c621df0",
  null
  
)

export default component.exports